import { supabase } from './supabaseClient';
import { Lancamento } from './types';

// Lançamentos
export const getLancamentos = async (filters: { obra_id?: number, fase_obra_id?: number, categoria_id?: number, fornecedor_id?: number, page?: number, pageSize?: number, search?: string, startDate?: string, endDate?: string, missingAttachments?: boolean } = {}) => {
    const { page = 0, pageSize = 1000000 } = filters; // Default to a large number if not specified to mimic "all"
    const offset = page * pageSize;

    const { data, error } = await supabase.rpc('get_lancamentos', {
        obra_id_filter: filters.obra_id,
        fase_id_filter: filters.fase_obra_id,
        cat_id_filter: filters.categoria_id,
        fornecedor_id_filter: filters.fornecedor_id,
        limit_val: pageSize,
        offset_val: offset,
        search_text: filters.search || null,
        start_date: filters.startDate || null,
        end_date: filters.endDate || null,
        missing_attachments: filters.missingAttachments || false
    });

    if (error) throw error;
    return data as { data: Lancamento[], total: number };
};

export const addLancamento = async (lancamentoData: any, itemsData: any[], anexosData: any[]) => {
    const { data, error } = await supabase.rpc('add_lancamento', { lancamento_data: lancamentoData, items_data: itemsData, anexos_data: anexosData });
    if (error) throw error;
    return data;
};

export const updateLancamento = async (lancamentoId: number, lancamentoData: any, itemsData: any[], anexosData: any[], anexosDeletadosIds: number[]) => {
    const { data, error } = await supabase.rpc('update_lancamento', { p_lancamento_id: lancamentoId, p_lancamento_data: lancamentoData, p_items_data: itemsData, p_anexos_data: anexosData, p_anexos_deletados_ids: anexosDeletadosIds });
    if (error) throw error;
    return data;
};

export const deleteLancamentoRecords = async (id: number) => {
    const { error } = await supabase.rpc('delete_lancamento_records', { lancamento_id_to_delete: id });
    if (error) throw error;
};

// Anexos
export const getStorageAnexoUrl = (bucketName: string, path: string) => {
    const { data } = supabase.storage.from(bucketName).getPublicUrl(path);
    return data.publicUrl;
};

export const getAnexoUrl = (path: string) => {
    return getStorageAnexoUrl('anexos', path);
};

export const deleteAnexosStorage = async (paths: string[]) => {
    if (!paths || paths.length === 0) return;
    const { error } = await supabase.storage.from('anexos').remove(paths);
    if (error) throw error;
};
